import { asType } from '@sparky/framework'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { CSP_LEARN_MORE_LINK } from '../constants'

export default asType<ActivationManifest>({
  activation_id: 'strata_insights',
  description: '',
  primary_app_id: PrimaryAppIds.STRATA_INSIGHTS,
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.UDefaultActivationScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now'
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.UScreenHeader',
            props: {
              title: 'Activate Product',
              headerAppId: PrimaryAppIds.STRATA_INSIGHTS,
              hideLicenseInfo: true,
              showAppTitle: true
            }
          },
          {
            key: 'activation-form',
            component: 'activation.UDefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              readActivationInstances: true,
              children: [
                {
                  key: 'activation-section-csp',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Select Customer Support Account',
                    subtitle: 'This account is used for the registration and support of the products and add-ons that are bundled with this subscription.',
                    link: CSP_LEARN_MORE_LINK,
                    children: [
                      {
                        key: 'activation-accordion-csp',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Customer Support Account:',
                          children: [
                            {
                              key: 'default-dropdown-component-csp',
                              component: 'activation.UCSPComponent',
                              props: {
                              },
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-section-subscription',
                        component: 'activation.UActivationSection',
                        props: {
                          title: 'Allocate This Product',
                          children: [
                            {
                              key: 'activation-accordion-tsg',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Recipient:',
                                children: [
                                  {
                                    key: 'default-tsg-component',
                                    component: 'activation.UTSGComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            },
                            {
                              key: 'activation-accordion-region',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Region:',
                                children: [
                                  {
                                    key: 'default-region-component',
                                    component: 'activation.URegionComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            }
                          ]
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'activation-accordion-cie',
                  component: 'activation.UAccordion',
                  props: {
                    title: 'Cloud Identity Engine',
                    hasDoneButton: true,
                    children: [
                      {
                        key: 'default-cie-field',
                        component: 'activation.DefaultCIEField',
                        props: {
                          group: 1,
                          readInstances: true,
                          cieDropDownProps: {
                            display: {
                              errorMessage: 'Select CIE to proceed activation',
                              subTitle: 'CIE instance for this tenant'
                            },
                            dropDownProps: {
                              required: true,
                              triggerValidationOnChange: true,
                            },
                            size: {
                              height: 32,
                              width: 355
                            },
                            passByProps: {
                              dataTestId: 'cie-activation-screen',
                              enableSearch: false,
                              label: '',
                              placeholder: 'Select CIE Instance',
                            }
                          }
                        }
                      }
                    ]
                  }
                },
                {
                  key: 'activation-device-onboarding',
                  component: 'activation.UAccordion',
                  props: {
                    group: 2,
                    children: [
                      {
                        key: 'device-onboarding-steps',
                        component: 'activation.UDeviceOnboardingStepsProp',
                        props: {
                          title: 'Device Onboarding Steps'
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'activation-banner',
                  component: 'activation.ActivationBanner',
                  props: {
                    group: 2,
                    appearance: 'standard',
                    type: 'inline',
                    infoMessage: 'We will automatically associate the product with all NGFW devices in your customer support account.',
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                }
              ]
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ]
      }
    }
  ]
})
